import TickerBar from "@/pages/home/components/TickerBar";
import { heroStats } from "@/mocks/homeData";

const quickEntries: { id: number; label: string; href: string; icon: string }[] = [
  { id: 1, label: "直播事故", href: "#categories", icon: "ri-mic-line" },
  { id: 2, label: "虚假宣称", href: "#categories", icon: "ri-alert-line" },
  { id: 3, label: "粉丝互撕", href: "#categories", icon: "ri-chat-smile-2-line" },
  { id: 4, label: "账号封禁", href: "#categories", icon: "ri-forbid-2-line" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20wide%20editorial%20photograph%20of%20an%20empty%20livestream%20studio%20at%20night%2C%20a%20lone%20condenser%20microphone%20and%20a%20blurred%20glowing%20ring%20light%2C%20tangled%20audio%20cables%20on%20a%20dark%20wooden%20desk%2C%20deep%20charcoal%20background%20with%20warm%20amber%20rim%20lighting%20and%20soft%20haze%2C%20moody%20atmospheric%20composition%2C%20subtle%20film%20grain%2C%20no%20people%2C%20no%20text%2C%20high%20detail%2C%20restrained%20minimalist%20aesthetic&width=1600&height=900&seq=hll-hero-01&orientation=landscape"
          alt="夜间直播间场景 · 黑料国产事件档案站"
          title="黑料国产 网红主播翻车现场档案"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/85"></div>
      </div>

      <div className="relative">
        <TickerBar />

        <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
          <div className="w-full max-w-3xl animate-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-3 py-1 text-xs text-background-200 backdrop-blur">
              <span className="flex h-3.5 w-3.5 items-center justify-center text-accent-300">
                <i className="ri-database-2-line"></i>
              </span>
              网络热点事件档案 · 每日按时间线整理
            </span>

            <h2 className="mt-5 font-heading text-3xl font-black leading-[1.2] text-background-50 md:text-[52px]">
              国产网红主播的翻车现场
              <br className="hidden md:block" />
              按时间线，一次翻完
            </h2>

            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
              直播事故、虚假宣称、粉丝互撕、账号封禁，四类事件分开归档。每条都标了出处与时间点，想看哪个达人的最新进展，直接点开就能顺着往下翻。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#community"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-chat-3-line"></i>
                </span>
                进入社区讨论
              </a>
              <a
                href="#feed"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/25 bg-white/5 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-white/10"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-flashlight-line"></i>
                </span>
                查看更新速递
              </a>
            </div>

            <div className="mt-7 flex flex-wrap items-center gap-2">
              <span className="text-xs text-background-300">快捷入口</span>
              {quickEntries.map((entry) => (
                <a
                  key={entry.id}
                  href={entry.href}
                  className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-white/15 bg-white/5 px-3 py-1.5 text-xs text-background-100 transition-colors hover:border-accent-400/60 hover:text-accent-200"
                >
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className={entry.icon}></i>
                  </span>
                  {entry.label}
                </a>
              ))}
            </div>
          </div>

          <div className="mt-12 grid max-w-4xl grid-cols-2 gap-3 md:mt-16 md:grid-cols-4 md:gap-5">
            {heroStats.map((stat, index) => (
              <div
                key={stat.id}
                className="animate-fade-up rounded-lg border border-white/10 bg-white/5 px-4 py-4 backdrop-blur"
                style={{ animationDelay: `${120 + index * 90}ms` }}
              >
                <span className="flex h-4 w-4 items-center justify-center text-accent-300">
                  <i className={stat.icon}></i>
                </span>
                <p className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">{stat.value}</p>
                <p className="mt-1 text-xs text-background-300">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}